import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { setAffiliateCookie } from '@lib/affiliate'

export function AffiliateTracker() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const ref = searchParams.get('ref')

    if (ref) {
      setAffiliateCookie(ref)
      trackAffiliateClick(ref)
    }
  }, [searchParams])

  const trackAffiliateClick = async (code: string) => {
    try {
      const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/track-affiliate-click`

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ affiliateCode: code }),
      })

      if (!response.ok) {
        console.error('Failed to track affiliate click:', await response.text())
      } else {
        const result = await response.json()
      }
    } catch (error) {
      console.error('Error tracking affiliate click:', error)
    }
  }

  return null
}
